import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=62aa49bc&scoped=true"
import script from "./richText.vue?vue&type=script&lang=js"
export * from "./richText.vue?vue&type=script&lang=js"
import style0 from "./richText.vue?vue&type=style&index=0&id=62aa49bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa49bc",
  null
  
)

export default component.exports